export default "__VITE_ASSET__0b9bb65b__"